export default "__VITE_ASSET__CZNwEk8U__ 100w";